import React from "react";
import { View, StyleSheet } from "@react-pdf/renderer";
import TableHeader from "../table/TableHeader";
import TableRow from "../table/TableRow";
import TableContact from "../table/TableContact";
import TableTotalSimple from "../table/TableTotalSimple";

const styles = StyleSheet.create({
  tableContainer: {
    flexDirection: "row",
    flexWrap: "wrap",
    marginTop: 10,
  },
});

const TableBooking = ({ invoice }) => {
  return (
    <View style={styles.tableContainer}>
      <TableContact name={invoice?.items[0]?.client_fullname} />
      <TableHeader />
      <TableRow items={invoice.items} />
      <TableTotalSimple invoice={invoice} />
    </View>
  );
};

export default TableBooking;
